/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Ai_Tools_TitleInputs */

const en_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Authoring Tools`)
};

const fr_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils de creation IA`)
};

const de_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Autorenwerkzeuge`)
};

const it_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti di creazione di intelligenza artificiale`)
};

const ru_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструменты для создания контента с использованием ИИ`)
};

const es_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de creación de IA`)
};

const zh_cn2_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能创作工具`)
};

const ja_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIオーサリングツール`)
};

const hi_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई ऑथरिंग टूल्स`)
};

const pt_pt2_event_ad_ai_tools_title = /** @type {(inputs: Event_Ad_Ai_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de autoria de IA`)
};

/**
* | output |
* | --- |
* | "AI Authoring Tools" |
*
* @param {Event_Ad_Ai_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_ai_tools_title = /** @type {((inputs?: Event_Ad_Ai_Tools_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Ai_Tools_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_ai_tools_title(inputs)
	if (locale === "de") return de_event_ad_ai_tools_title(inputs)
	if (locale === "it") return it_event_ad_ai_tools_title(inputs)
	if (locale === "ru") return ru_event_ad_ai_tools_title(inputs)
	if (locale === "es") return es_event_ad_ai_tools_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_ai_tools_title(inputs)
	if (locale === "ja") return ja_event_ad_ai_tools_title(inputs)
	if (locale === "hi") return hi_event_ad_ai_tools_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_ai_tools_title(inputs)
	return en_event_ad_ai_tools_title(inputs)
});